// @flow
import type { StoreResourceDef, Schema } from 'app/core/types'

export const peopleSchemas: StoreResourceDef<Schema<>> = {
  resourceType: 'peopleSchemas',
}
